// 開発時のみ使用するため、無視する。
/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';

const BASE_URL = process.env.REACT_APP_API_DOMAIN ?? 'http://localhost:3000';

/** トレーニング情報取得APIで返すセンテンス一覧 */
const sentences = [
  {
    english: {
      id: '0-1',
      start: 4.0,
      end: 6.0,
      text: 'One Promposal',
    },
  },
  {
    english: {
      id: '1-1',
      start: 6.5,
      end: 8.5,
      text: 'I have a pen.',
    },
    japanese: {
      id: '1-2',
      start: 10.5,
      end: 12.5,
      text: '私はペンを持っています。',
    },
  },
  {
    english: {
      id: '1-3',
      start: 14.5,
      end: 16.5,
      text: 'This is a pen.',
    },
    japanese: {
      id: '1-4',
      start: 18.5,
      end: 20.5,
      text: 'これはペンです。',
    },
  },
  {
    english: {
      id: '1-5',
      start: 21.5,
      end: 23.5,
      text: "I'm from japan.",
    },
    japanese: {
      id: '1-6',
      start: 24.5,
      end: 26.5,
      text: '私の出身は日本です。',
    },
  },
  {
    english: {
      id: '1-7',
      start: 300.0323232,
      end: 320.02321342,
      text: 'his name is Tom.',
    },
    japanese: {
      id: '1-8',
      start: 320.5,
      end: 350.5,
      text: '彼の名前は、トムです。',
    },
  },
];

const handlers = [
  rest.post(
    `${BASE_URL}/superelmer-server/serial/certification`,
    (req, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          result_code: 'OK',
          accesskey: 'FjAHF723r712yfasiufahhsufaihfanbAFh7waf',
        }),
      ),
  ),

  rest.post(`${BASE_URL}/superelmer-server/serial/info`, (req, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        result_code: 'OK',
        serial: {
          number: 'ABCDE-1234567890123456',
          product_name: 'スーパーエルマー',
          course_name: 'STANDARD',
        },
      }),
    ),
  ),

  rest.post(
    `${BASE_URL}/superelmer-server/training/progress/reset`,
    (req, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          result_code: 'OK',
        }),
      ),
  ),

  rest.post(`${BASE_URL}/superelmer-server/logoff`, (req, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        result_code: 'OK',
      }),
    ),
  ),

  rest.post(`${BASE_URL}/superelmer-server/contents/list`, (req, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        result_code: 'OK',
        contents: [
          {
            lesson_id: 1,
            topic_id: 1,
            number: '1-1',
            description: 'Growing Unusual Vegetables',
            is_completed: true,
            playdt: '2021-11-25T01:02:03.004Z',
            hop_id: 1,
            skip_id: 2,
            jump_id: 3,
          },
          {
            lesson_id: 1,
            topic_id: 2,
            number: '1-2',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-11-01T01:02:03.004Z',
            hop_id: 4,
            skip_id: 5,
            jump_id: 6,
          },
          {
            lesson_id: 1,
            topic_id: 3,
            number: '1-3',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-10-07T01:02:03.004Z',
            hop_id: 7,
            skip_id: 8,
            jump_id: 9,
          },
          {
            lesson_id: 2,
            topic_id: 1,
            number: '2-1',
            description: 'Growing Unusual Vegetables',
            is_completed: true,
            playdt: '2021-11-25T01:02:03.004Z',
            hop_id: 10,
            skip_id: 11,
            jump_id: 12,
          },
          {
            lesson_id: 2,
            topic_id: 2,
            number: '2-2',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-11-01T01:02:03.004Z',
            hop_id: 13,
            skip_id: 14,
            jump_id: 15,
          },
          {
            lesson_id: 2,
            topic_id: 3,
            number: '2-3',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-10-07T01:02:03.004Z',
            hop_id: 16,
            skip_id: 17,
            jump_id: 18,
          },
          {
            lesson_id: 3,
            topic_id: 1,
            number: '3-1',
            description: 'Growing Unusual Vegetables',
            is_completed: true,
            playdt: '2021-11-25T01:02:03.004Z',
            hop_id: 19,
            skip_id: 20,
            jump_id: 21,
          },
          {
            lesson_id: 3,
            topic_id: 2,
            number: '3-2',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-11-01T01:02:03.004Z',
            hop_id: 22,
            skip_id: 23,
            jump_id: 24,
          },
          {
            lesson_id: 3,
            topic_id: 3,
            number: '3-3',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-10-07T01:02:03.004Z',
            hop_id: 25,
            skip_id: 26,
            jump_id: 27,
          },
          {
            lesson_id: 4,
            topic_id: 1,
            number: '4-1',
            description: 'Growing Unusual Vegetables',
            is_completed: true,
            playdt: '2021-11-25T01:02:03.004Z',
            hop_id: 28,
            skip_id: 29,
            jump_id: 30,
          },
          {
            lesson_id: 4,
            topic_id: 2,
            number: '4-2',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-11-01T01:02:03.004Z',
            hop_id: 31,
            skip_id: 32,
            jump_id: 33,
          },
          {
            lesson_id: 4,
            topic_id: 3,
            number: '4-3',
            description: 'Growing Unusual Vegetables',
            is_completed: false,
            playdt: '2021-10-07T01:02:03.004Z',
            hop_id: 34,
            skip_id: 35,
            jump_id: 36,
          },
        ],
        resume: {
          number: '1-1',
          description: 'Growing Unusual Vegetables',
          training_id: 1,
          sentence_id: '1-1',
        },
      }),
    ),
  ),

  rest.post(`${BASE_URL}/superelmer-server/training/info`, (req, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({
        result_code: 'OK',
        training_type: 'HOP',
        description: 'Growing Unusual Vegetables',
        sentences,
        audio: {
          url: 'https://d3bqpqbdx7e54k.cloudfront.net/sample-music/audio.m3u8',
          policy: 'abcdefgxxxxxxxxxx',
          signature: 'hijklmnxxxxxxxxxx',
          key_pair_id: 'OPQRSTUXXXXXXXXXX',
        },
        isCompleted: true,
        sentenceId: '1-7',
      }),
    ),
  ),

  rest.post(`${BASE_URL}/superelmer-server/sentence/status`, (req, res, ctx) =>
    res(
      ctx.delay(2000),
      ctx.status(200),
      ctx.json({
        result_code: 'OK',
      }),
    ),
  ),
];

export default handlers;
